import { runAtInterval } from './helpers';

export default function setupSegmentTracking(player) {
  let percentsAlreadyTracked = [];

  if (
    player.el().dataset.trackPreSales != undefined &&
    player.el().dataset.videoDuration != (undefined || 0)
  ) {
    runAtInterval(player, 10, checkPresalesSegmentTrack);
  } else if (
    player.el().dataset.noCourseAccessLesson != undefined &&
    player.el().dataset.videoDuration != (undefined || 0)
  ) {
    runAtInterval(player, 10, checkLessonSegmentTrack);
  }

  function checkPresalesSegmentTrack() {
    // will track at 10, 25, 50, 75 and 90 % intervals
    /* eslint-disable no-undef */
    let currentTime = player.currentTime();
    let duration = player.el().dataset.videoDuration / 1000;
    let percentPlayed = Math.round((currentTime / duration) * 100);

    const percentages = [10, 25, 50, 75, 90];
    for (let i = 0; i < percentages.length; i++) {
      let percent = percentages[i];
      if (
        percentPlayed >= percent &&
        !percentsAlreadyTracked.includes(percent)
      ) {
        sendSegmentPresalesTrack(percent);
        percentsAlreadyTracked.push(percent);
      }
    }
    /* eslint-enable no-undef */
  }

  function checkLessonSegmentTrack() {
    // will track at 10, 25, 50, 75 and 90 % intervals'
    /* eslint-disable no-undef */
    let currentTime = player.currentTime();
    let duration = player.el().dataset.videoDuration / 1000;
    let percentPlayed = Math.round((currentTime / duration) * 100);

    const percentages = [10, 25, 50, 75, 90];
    for (let i = 0; i < percentages.length; i++) {
      let percent = percentages[i];
      if (
        percentPlayed >= percent &&
        !percentsAlreadyTracked.includes(percent)
      ) {
        sendSegmentNoCourseAccessLessonTrack(percent);
        percentsAlreadyTracked.push(percent);
      }
    }
    /* eslint-enable no-undef */
  }

  function sendSegmentPresalesTrack(percent) {
    /* eslint-disable no-undef */
    const courseId = player.el().dataset.courseId;
    const labelName = player.el().dataset.trackingLabelName;
    const variantName = player.el().dataset.trackingVariantName;

    const url = '/track_presales_video_watch';
    const data = {
      course_id: courseId,
      percent: percent,
      label_name: labelName,
      variant_name: variantName,
    };

    $.ajax({
      type: 'POST',
      url: url,
      data: data,
      dataType: 'json'
    });
    /* eslint-enable no-undef */
  }

  function sendSegmentNoCourseAccessLessonTrack(percent) {
    const lessonId = player.el().dataset.lessonId;

    if (lessonId) {
      $.ajax({
        type: "POST",
        url: "/track_no_course_access_lesson_video_watch",
        data: {
          lesson_id: lessonId,
          percent: percent,
        },
        dataType: "json",
      });
    }
  }
}
